import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "main",
  id: "egcf-speaker-main"
}
const _hoisted_2 = { class: "main-header" }
const _hoisted_3 = { class: "search-input-container" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "speaker-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "speaker-info-container" }
const _hoisted_8 = { class: "speaker-name" }
const _hoisted_9 = { class: "speaker-position" }
const _hoisted_10 = {
  key: 0,
  class: "empty-search-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_speaker_detail_dialog = _resolveComponent("speaker-detail-dialog")!
  const _component_lazy_load_container = _resolveComponent("lazy-load-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_speaker_detail_dialog, {
      "get-lang-for-speech": _ctx.getLangForSpeechById,
      ref: "speakerDetailDialog"
    }, null, 8, ["get-lang-for-speech"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
                spellcheck: "false",
                autocapitalize: "none",
                placeholder: _ctx.$t('search-input-placeholder')
              }, null, 8, _hoisted_4), [
                [_vModelText, _ctx.searchValue]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speakers, (speaker) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "speaker",
                onClick: ($event: any) => (_ctx.openSpeakerDetailDialog(speaker,$event))
              }, [
                _createVNode(_component_lazy_load_container, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "speaker-image",
                      style: _normalizeStyle([speaker.hasPicture() ? {'background-image':'url('+ speaker.getPictureUrl()+')'} : {} ])
                    }, null, 4),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(speaker.displayName), 1),
                      _createElementVNode("small", _hoisted_9, _toDisplayString(speaker.company), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ], 8, _hoisted_6))
            }), 256)),
            (_ctx.searchValue && _ctx.speakers.length === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('empty-search-results')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            ref: "scrollToTopButton",
            class: "scroll-to-top-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "white",
              viewBox: "0 0 448 512"
            }, [
              _createElementVNode("path", { d: "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z" })
            ], -1)
          ]))], 512)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}